import {AfterViewInit, Component, ElementRef, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import * as $ from "jquery/dist/jquery.min.js";
import {ShareButtons} from "@ngx-share/core";
import {AuthServices} from "../services/auth.service";
import {User} from "../models/user.model";


@Component({
    selector: 'app-tours',
    templateUrl: './tours.component.html'
})
export class ToursComponent implements OnInit, AfterViewInit {
    public slug;
    tour = {
        "id": null,
        "title": null,
        "slug": null,
        "price": null,
        "discount": null,
        "tour_length": null,
        "content": null,
        "address": null,
        "latitude": null,
        "longitude": null,
        "email": null,
        "phone": null,
        "opening_time": null,
        "closing_time": null,
        "fee": null,
        "website": null,
        "thumbnail_image": null,
        "map_image": null,
        'tour_code': null,
        "tour_operator": null
    };

    offer = {
        'price': 0,
        'saving': 0,
        'daily': 0
    };

    galleryOptions = [
        {
            width: '100%',
            height: '673px',
            thumbnailsColumns: 4,
            imagePercent: 80,
            thumbnailsPercent: 17,
            thumbnailsMargin: 5,
            thumbnailMargin: 5
        },

    ];

    itinerary_galleryOptions = [
        {
            thumbnails: false,
            width: "100%",
            height: "300px"
        }
    ];

    galleryImages = [];
    tour_images = [];
    tour_itinerary = [];

    destinations = [];

    tour_operator = {};

    reviews_avg = {};
    reviews = [];
    next = null;

    similar_tours = [];

    auth_user = new User();

    headersHeight: number;

    constructor(public share: ShareButtons,
                private route: ActivatedRoute,
                private router: Router,
                private http: HttpClient,
                public _auth: AuthService,
                private authService: AuthServices,
                private el: ElementRef) {

    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.slug = params['slug'];
            this.galleryImages = [];
            this.tour_images = [];
            this.getTour();
            this.getReviews();
            this.getSimilarTours();
        });

        this.authService.currentUser.subscribe((user: User) => {
            this.auth_user = user;
        });

    }

    ngAfterViewInit(): void {
        this.headersHeight = $('#header').height() + $('div.fixed-nav').height();
    }

    getTour() {
        this.http.get(Conf.API_URL + '/tour/?slug=' + this.slug).subscribe(
            data => {
                if (data['results'].length) {
                    this.tour = data['results'][0];

                    this.getTourImages();

                    if (this.tour.discount) {
                        this.offer.saving = Math.round(this.tour.price * this.tour.discount / 100);
                    }
                    this.offer.price = this.tour.price - this.offer.saving;
                    if (this.tour.tour_length > 1) {
                        this.offer.daily = Math.floor(this.offer.price / this.tour.tour_length);
                    } else {
                        this.offer.daily = this.offer.price;
                    }

                    if (this.tour.tour_operator) {
                        this.http.get(Conf.API_URL + '/tour-operators/' + this.tour.tour_operator).subscribe(
                            data => {
                                this.tour_operator = data;
                            },
                            error => {
                                console.log(error.error)
                            }
                        );
                    }
                    this.http.get(Conf.API_URL + '/tour-itinerary/?show_all&images&tour=' + this.tour.id).subscribe(
                        data => {
                            this.tour_itinerary = data['results'];
                            let this_m = this;
                            $.each(this.tour_itinerary, function (index, itinerary) {
                                this_m.tour_itinerary[index]['images'] = this_m.galleryImagesFormat(itinerary.images)
                                if (this_m.destinations.indexOf(itinerary.place) < 0) {
                                    this_m.destinations.push(itinerary.place)
                                }
                            });
                        },
                        error => {
                            console.log(error.error)
                        }
                    );
                } else {
                    this.router.navigateByUrl('/404');
                    return false;
                }
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getSimilarTours() {
        this.http.get(Conf.API_URL + '/get-similar-tours/?slug=' + this.slug).subscribe(
            data => {
                this.similar_tours = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }


    getTourImages() {
        this.http.get(Conf.API_URL + '/tour-images/?tour__slug=' + this.slug).subscribe(
            data => {
                this.tour_images = data['results'];

                let this_m = this;

                $.each(this.tour_images, function (index, value) {
                    if (this_m.tour.map_image != value.id) {
                        this_m.galleryImages.push({
                            small: value.image,
                            medium: value.image,
                            big: value.image
                        })
                    }
                });
            },
            error => {
                console.log(error.error)
            }
        );
    }

    galleryImagesFormat(images) {
        var gallery_images = [];
        $.each(images, function (index, image) {
            gallery_images.push({
                small: image,
                medium: image,
                big: image
            })
        });

        return gallery_images;
    }


    getReviews(type = 'All') {
        var url = Conf.API_URL + '/tour-reviews/?tour__slug=' + this.slug;
        var url_avg = Conf.API_URL + '/tour-reviews-avg/?tour=' + this.slug;
        if (type != 'All') {
            url += '&sort=' + type;
            url_avg += '&sort=' + type;
        }

        this.http.get(url_avg).subscribe(
            data => {
                this.reviews_avg = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );

        this.http.get(url).subscribe(
            data => {
                this.reviews = data['results'];
                this.next = data['next'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    loadMore() {
        this.http.get(this.next).subscribe(
            data => {
                this.reviews = this.reviews.concat(data['results']);
                this.next = data['next'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    splitData(html) {
        return html.split(/\n/);
    }

    setTabActive($event): void {
        $('li.tab-link a').removeClass('active');
        $event.target.classList.add('active');
    }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/tours/tours.component.ts